import { useSpendSummary } from '@/api/hooks';
import { formatMoney, formatSignedPercent } from '@/lib/format';

/**
 * Нижний блок сайдбара: траты за текущий месяц и разница с прошлым
 * (docs/08-screens.md). Главная цифра — рубли, под ней доллары
 * (docs/04-finance.md). Полосы заполнения нет: месячный потолок не задаётся.
 */
export function MoneySummary({ enabled }: { enabled: boolean }) {
  const { data, isLoading } = useSpendSummary(enabled);

  const monthName = new Intl.DateTimeFormat('ru-RU', {
    month: 'long',
    timeZone: 'Europe/Moscow',
  }).format(new Date());

  return (
    <div
      style={{
        background: 'var(--surface-muted)',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--space-5)',
      }}
    >
      <div style={{ font: '600 13px var(--font-text)', color: 'var(--burgundy-800)' }}>
        Траты за {monthName}
      </div>

      <div
        style={{
          marginTop: 'var(--space-3)',
          font: '500 20px var(--font-mono)',
          color: 'var(--burgundy-800)',
        }}
      >
        {isLoading || !data ? '—' : formatMoney(data.current.amountMinor, 'RUB')}
      </div>

      {data && data.hasData ? (
        <div
          style={{
            marginTop: 'var(--space-1)',
            font: '400 13px var(--font-mono)',
            color: 'var(--burgundy-800)',
            opacity: 0.75,
          }}
        >
          {formatMoney(data.current.usdMinor, 'USD')}
        </div>
      ) : null}

      {data && data.current.unratedUsdMinor > 0 ? (
        <div
          style={{
            marginTop: 'var(--space-2)',
            font: '400 12px/1.45 var(--font-text)',
            color: 'var(--status-warning-fg)',
          }}
        >
          {`Без курса в рубли не вошло ${formatMoney(data.current.unratedUsdMinor, 'USD')}`}
        </div>
      ) : null}

      <div
        style={{
          marginTop: 'var(--space-2)',
          font: '400 12px/1.45 var(--font-text)',
          color: 'var(--burgundy-800)',
          opacity: 0.75,
        }}
      >
        {!data
          ? 'Считаем'
          : !data.hasData
            ? 'Данных о тратах пока нет'
            : data.changePercent === null
              ? 'Сравнить не с чем: прошлый месяц пуст'
              : `${formatSignedPercent(data.changePercent)} к прошлому месяцу`}
      </div>
    </div>
  );
}
